import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Payment } from '../types';

export function usePaidPayments() {
  return useQuery({
    queryKey: ['payments-paid'],
    queryFn: async (): Promise<Payment[]> =>
      pb.send('/api/payments/paid', { method: 'GET' }),
    staleTime: 30_000,
  });
}
